// style
import NavigationBar from "components/gnb/NavigationBar/NavigationBar";
import { StyledLayout } from "./style";
// components
import { TitleBar } from "components/gnb/TitleBar/TitleBar";
import React, { useEffect, useMemo, useState } from "react";
import useTableDataStore from "store/project/data/useTableDataStore";
import useLayoutStore from "store/useLayoutStore";
import { ELECTRON_API } from "config";
import { useTitleBar } from "hooks/useTitleBar";

interface LayoutProps {
  children: React.ReactNode;
}
export interface ToggleSidebarType {
  [key: string]: boolean;
}

const MemoizedLayout = React.memo(Layout);

function Layout({ children }: LayoutProps) {
  const { isSubTab, isHeader } = useLayoutStore();
  const { isFullScreen } = useTableDataStore();
  const { isTitleBar } = useTitleBar();

  const height = useMemo(() => {
    let excludeHeight = 0;
    if (isTitleBar) excludeHeight += 26;
    if (isHeader && !isFullScreen) excludeHeight += 56;
    if (isSubTab) excludeHeight += 37;

    return `calc(100% - ${excludeHeight}px)`;
  }, [isTitleBar, isHeader, isFullScreen, isSubTab]);

  return (
    <StyledLayout>
      {isTitleBar && <TitleBar />}
      <div className="header-wrap">{isHeader && <NavigationBar />}</div>
      <div className="main-wrap" style={{ height }}>
        <div className="main-contents">{children}</div>
      </div>
    </StyledLayout>
  );
}

export default MemoizedLayout;
